<template>
  <v-btn
    data-testid="StudentWheelPicker-toggle"
    rounded="pill"
    class="student-wheel-picker-btn"
    :class="{ active: studentWheelStore.modalOpen }"
    @click.stop="toggle"
  >
    <v-icon class="student-wheel-picker-icon">fa-light fa-dharmachakra</v-icon>
    <span class="d-none d-md-inline">{{ studentWheelStore.modalOpen ? "Izslēgt" : "Izsaukt" }}</span>
  </v-btn>
</template>

<script lang="ts">
import { useStudentWheelStore } from "~/stores/studentWheelStore"

export default {
  setup() {
    const studentWheelStore = useStudentWheelStore()
    return { studentWheelStore }
  },

  methods: {
    toggle() {
      this.studentWheelStore.setModalOpen(!this.studentWheelStore.modalOpen)
    },
  },
}
</script>

<style lang="sass" scoped>
.student-wheel-picker-btn
  text-transform: none
  letter-spacing: 0.1px
  font-weight: 400
  font-size: 16px
  line-height: 20px
  min-width: 0

  &.active
    background-color: #FFF1AE

.student-wheel-picker-icon
  margin-right: 8px
</style>
